// Apolo IDE — Auto-review local telemetry (S4 · E4-WS1-T04).
//
// Counts only — NO PII (no tool args, no paths, no content; just decision tallies).
// Used to surface "% blocked" and "% interrupted turns" discreetly in the UI.

/** A fresh per-turn accumulator. */
export function createAutoReviewMetrics() {
  return { total: 0, allowed: 0, blocked: 0, asked: 0 };
}

/** Tally one decision. Unknown/absent decisions are ignored. */
export function recordDecision(m, decision) {
  if (!m) return;
  m.total += 1;
  if (decision === 'block') m.blocked += 1;
  else if (decision === 'ask') m.asked += 1;
  else if (decision === 'allow') m.allowed += 1;
  else m.total -= 1; // not a real decision — undo
}

/** Fraction of reviewed tool calls that were blocked (0 when none). */
export function blockedRate(m) {
  return m && m.total > 0 ? m.blocked / m.total : 0;
}

/** Summarize one turn (additive to the loop result; counts only). */
export function summarize(m) {
  const total = m?.total ?? 0;
  const blocked = m?.blocked ?? 0;
  return {
    total,
    allowed: m?.allowed ?? 0,
    blocked,
    asked: m?.asked ?? 0,
    blockedRate: blockedRate(m),
    interrupted: blocked > 0, // this turn had >=1 blocked tool call
  };
}

/**
 * Aggregate per-turn summaries → interruptedTurnRate (fraction of turns where
 * auto-review blocked at least one tool call). Caller accumulates summaries.
 */
export function interruptedTurnRate(turnSummaries) {
  const arr = Array.isArray(turnSummaries) ? turnSummaries : [];
  if (arr.length === 0) return 0;
  const interrupted = arr.filter((s) => s && s.interrupted).length;
  return interrupted / arr.length;
}
